import React, { useEffect, useState } from "react";
import {
    ArrowLeft,
    ArrowUpRight,
    CalendarBlank,
    CheckCircle,
    Funnel,
    X,
    XCircle,
} from "@phosphor-icons/react";
import axiosInstance from "../../api/axiosInstance";
import { useQuery } from "@tanstack/react-query";
import PageLoader from "../loader/PageLoader";
import PrePostCabModal from "../PastRequestsModals/PrePostCabModal";
import PreEarlyCheckinModal from "../PastRequestsModals/PreEarlyCheckinModal";
import PostLateCheckoutModal from "../PastRequestsModals/PostLateCheckoutModal";
import WakeUpCallModal from "../PastRequestsModals/WakeUpCallModal";
import HouseKeepingModal from "../PastRequestsModals/HouseKeepingModal";
import ConferenceRoomModal from "../PastRequestsModals/ConferenceRoomModal";
import RestaurantTableModal from "../PastRequestsModals/RestaurantTableModal";
import SpaRequestModal from "../PastRequestsModals/SpaRequestModal";
import CustomModel from "../PastRequestsModals/CustomModel";
import RoomChangeModel from "../PastRequestsModals/RoomChangeModel";
import ExtendStayModel from "../PastRequestsModals/ExtendStayModel";
import GetWifiModel from "../PastRequestsModals/GetWifiModel";
import DiningModel from "../PastRequestsModals/DinningModel";
import WebCheckInRequestModel from "../PastRequestsModals/WebCheckInRequestModel";
import Checkout from "../PastRequestsModals/CheckOutModel";
// import { type } from "@testing-library/user-event/dist/type";

const PastRequests = ({ closePast }) => {
    
    const [filteredData, setFilteredData] = useState([]);
    
    const [appliedFilters, setAppliedFilters] = useState({
        roomNumber: "",
        preCheckin: false,
        postCheckin: false,
        staff: "",
        month: "",
        year: "",
        date: "", 
        startDate: "",    
        endDate: "",   
    });
    
    
    const [tempFilters, setTempFilters] = useState({
        roomNumber: "",
        preCheckin: false,
        postCheckin: false,
        staff: "",
        month: "",
        year: "",
        date: "", 
        startDate: "",    
        endDate: "",   
    });

    const [openFilter, setOpenFilter] = useState(false);
    
    // const userId = localStorage.getItem("userId");
    const hotelId = localStorage.getItem("hotelId");

    const fetchPastReq = async () => {
        try {
            const response = await axiosInstance.get(
                `api/v1/hotels/${hotelId}/past-requests`,
            );
            return response.data.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    };

    const {
        data: fetchData,
        isLoading,
        isFetching,
        refetch,
        error,
    } = useQuery({
        queryKey: ["pastRequests", hotelId],
        queryFn: fetchPastReq,
        refetchOnWindowFocus: true,
        staleTime: 5000,
        refetchInterval: 3000,
    });

    useEffect(() => {
        if (fetchData) {
            applyFiltersAndSort(fetchData);
        }
    }, [fetchData, appliedFilters]);

    const handleFilterChange = (e) => {
        try{
            const { name, value, type, checked } = e.target;
            setTempFilters((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value,
            }));
        }catch(error){
            console.log(error);
        }
    };

    // Filters Reset Function
    const resetFilters = () => {
        try{
            const resetState = {
                roomNumber: "",
                preCheckin: false,
                postCheckin: false,
                staff: "",
                month: "",
                year: "",
                date: "", 
                startDate: "",
                endDate: "",
            };
    
            setTempFilters(resetState);
            setAppliedFilters(resetState);
        }catch(error){
            console.log(error);
        }
    };

    
    // Button to apply filters
    const applyFilters = () => {
        try{
            console.log("Temp Filters : ",tempFilters)
            setAppliedFilters(tempFilters);
            setOpenFilter(false);
        }catch(error){
            console.log(error);
        }
    };

 
    // Function to apply filters and sorting to the data
    const applyFiltersAndSort = (data) => {
        try {
            let filteredRequests = data.filter((request) =>
                [
                    "Declined_Hotel",
                    "Completed_Hotel",
                    "Closed_Hotel",
                    "Declined_Guest",
                    "Closed_Guest",
                ].includes(request.status)
            );

            filteredRequests = filteredRequests.filter((d) => {
                const updatedDate = new Date(d.updated_at);

                const roomNumberMatch =
                    !appliedFilters.roomNumber ||
                    d.room_number?.toString() === appliedFilters.roomNumber;

                const checkinStatusMatch =
                    (!appliedFilters.preCheckin && !appliedFilters.postCheckin) ||
                    (appliedFilters.preCheckin &&
                    serviceMap[d.type] === "Pre-Checkin") ||
                    (appliedFilters.postCheckin &&
                    serviceMap[d.type] === "Post-Checkin");

                const staffMatch =
                    !appliedFilters.staff ||
                    d.staff_member_name === appliedFilters.staff;

                const yearMatch =
                    !appliedFilters.year ||
                    updatedDate.getFullYear().toString() === appliedFilters.year;

                const monthMatch =
                    appliedFilters.month === "" ||
                    updatedDate.getMonth().toString() === appliedFilters.month;

                const dateMatch =
                    appliedFilters.date === "" ||
                    updatedDate.getDate().toString() === appliedFilters.date;  

                const startDateMatch =
                    !appliedFilters.startDate ||
                    new Date(d.updated_at) >= new Date(appliedFilters.startDate);

                const endDateMatch =
                    !appliedFilters.endDate ||
                    new Date(d.updated_at) <= new Date(appliedFilters.endDate + "T23:59:59");


                return (
                    roomNumberMatch &&
                    checkinStatusMatch &&
                    staffMatch &&
                    // Date Month Year Match
                    yearMatch &&
                    monthMatch &&
                    dateMatch &&
                    // Start Date and End Date Match
                    endDateMatch &&
                    startDateMatch  
                );
            });

            filteredRequests.sort(
            (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
            );

            setFilteredData(filteredRequests);
        } catch (error) {
            console.log(error);
        }
    };



    const getRelativeTime = (timestamp) => {
        const now = new Date();
        const updated = new Date(timestamp);
        const diffInSeconds = Math.floor((now - updated) / 1000);

        if (diffInSeconds < 60) return `${diffInSeconds}sec ago`;
        if (diffInSeconds < 3600)
            return `${Math.floor(diffInSeconds / 60)}min ago`;
        if (diffInSeconds < 86400)
            return `${Math.floor(diffInSeconds / 3600)}hr ago`;
        const days = Math.floor(diffInSeconds / 86400);
        return `${days} ${days > 1 ? "days ago" : "day ago"}`;
    };

    const serviceMap = {
        HouseKeeping: "Post-Checkin",
        "In Room Dining": "Post-Checkin",
        "PreCheckin Cab Request": "Pre-Checkin",
        "PostCheckin Cab Request": "Post-Checkin",
        Checkout: "Post-Checkin",
        "Conference Room": "Post-Checkin",
        "Custom Request": "Post-Checkin",
        "PreCheckin Early Checkin Request": "Pre-Checkin",
        "PostCheckin ExtendStay Request": "Post-Checkin",
        "PostCheckin Late Checkout Request": "Post-Checkin",
        "Restaurant Table": "Post-Checkin",
        "PostCheckin Room Change Request": "Post-Checkin",
        Spa: "Post-Checkin",
        "Wake Up Call": "Post-Checkin",
        "Web Checkin": "Pre-Checkin",
        "Get Wifi": "Post-Checkin",
    };

    // console.log("Fetch Data : ",fetchData);


    const [requestType,setRequestType] = useState("");
    const [requestData,setRequestData] = useState(null);
    const [openRequestModal,setOpenRequestModal] = useState(false);

    const openRequest=async(requestId,type,bookingId,roomId)=>{
        try{
            const hotelID = localStorage.getItem("hotelId")

            if(type==="PreCheckin Cab Request"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/pre-post-request/cab-request?guest_request_id=${requestId}`);
                // console.log("Response for Request : ",response.data);
                setRequestData(response.data);
                setRequestType("cab");
                setOpenRequestModal(true); 
            }
            if(type==="PostCheckin Cab Request"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/pre-post-request/cab-request?guest_request_id=${requestId}`);
                // console.log("Response for Request : ",response.data);
                setRequestData(response.data);
                setRequestType("cab");
                setOpenRequestModal(true); 
            }
            if(type==="PreCheckin Early Checkin Request"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/pre-checkin/early-checkin-request?guest_request_id=${requestId}`);
                // console.log("Response for Request : ",response.data);
                setRequestData(response.data);
                setRequestType("earlyCheckIn");
                setOpenRequestModal(true);
            }
            if(type==="PostCheckin Late Checkout Request"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/late-checkout-request?guest_request_id=${requestId}`);
                setRequestData(response.data);
                setRequestType("lateCheckout");
                setOpenRequestModal(true);
            }
            if(type==="Wake Up Call"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/wakeup-call-request?guest_request_id=${requestId}`);
                // console.log("Response for Request : ",response.data);
                setRequestData(response.data);
                setRequestType("wakeUpCall");
                setOpenRequestModal(true); 
            }
            if(type==="HouseKeeping"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/housekeeping-request?guest_request_id=${requestId}`);
                // console.log("Response for Request House: ",response.data);
                setRequestData(response.data);
                setRequestType("houseKeeping");
                setOpenRequestModal(true); 
            }
            if(type==="Conference Room"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/conference-room-request?guest_request_id=${requestId}`);
                // console.log("Response for Request Conference Room : ",response.data);
                setRequestData(response.data);
                setRequestType("conferenceRoom");
                setOpenRequestModal(true); 
            }
            if(type==="Restaurant Table"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/restaurant-table-request?guest_request_id=${requestId}`);
                // console.log("Response for Request Restaurant Table : ",response.data);
                setRequestData(response.data);
                setRequestType("restaurantTable");
                setOpenRequestModal(true); 
            }
            if(type==="Spa"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/spa-request?guest_request_id=${requestId}`);
                // console.log("Response for Request Spa  : ",response.data);
                setRequestData(response.data);
                setRequestType("spa");
                setOpenRequestModal(true); 
            }
            if(type==="Custom Request"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/custom-request?guest_request_id=${requestId}`);
                // console.log("Response for Request Custom  : ",response.data);
                setRequestData(response.data);
                setRequestType("custom");
                setOpenRequestModal(true); 
            }
            if(type==="PostCheckin Room Change Request"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/room-change-request?guest_request_id=${requestId}`);
                // console.log("Response for Request Room Change  : ",response.data);
                setRequestData(response.data);
                setRequestType("roomChange");
                setOpenRequestModal(true); 
            }
            if(type==="PostCheckin ExtendStay Request"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/extend-stay-request?guest_request_id=${requestId}`);
                // console.log("Response for Request Extend Stay  : ",response.data);
                setRequestData(response.data);
                setRequestType("extendStay");
                setOpenRequestModal(true); 
            }
            if(type==="Get Wifi"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/wifi-request?guest_request_id=${requestId}`);
                // console.log("Response for Request getWifi  : ",response.data);
                setRequestData(response.data);
                setRequestType("getWifi");
                setOpenRequestModal(true); 
            }
            if(type==="In Room Dining"){
                const response = await axiosInstance.get(`/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/food-request?guest_request_id=${requestId}`);
                // console.log("Response for Request Food  : ",response.data);
                setRequestData(response.data);
                setRequestType("food");
                setOpenRequestModal(true); 
            }
            if(type==="Web Checkin"){

                const response = await axiosInstance.get(
                    `/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/web-checkin`,
                );
                // console.log("Response for Request WebCheckIn : ",response.data);
                setRequestData({
                    hotelId : hotelID,
                    bookingId : bookingId,
                    bookedRoomId : roomId
                });
                setRequestType("webCheckIn");
                setOpenRequestModal(true); 
            }
            if(type==="Checkout"){
                const response = await axiosInstance.get(
                `/api/v1/hotels/${hotelID}/bookings/${bookingId}/booked-rooms/${roomId}/guest-requests/post-checkin/checkout-request?guest_request_id=${requestId}`);
                console.log("Response for Checkout request : ",response.data);
                setRequestData({
                    hotelId : hotelID,
                    bookingId : bookingId,
                    bookedRoomId : roomId,
                    requestId : requestId
                });
                setRequestType("checkOut");
                setOpenRequestModal(true); 
            }
            if(type==="Restaurant Dining"){
                 const response = await axiosInstance.get(
                    `/api/v1/hotels/${hotelID}/restaurant-food-request`,
                    {
                        params: {
                            guest_request_id: requestId,
                        },
                    },
                );
                setRequestData(response.data);
                setRequestType("food");
                setOpenRequestModal(true); 
            }



        }catch(error){
            console.log(error);
        }
    }

    const renderRequestModal=(requestType)=>{
        try{
            // console.log('Render Request',requestType)
            if(requestType==="cab"){
                // console.log("Here in Request")
                return <PrePostCabModal
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="earlyCheckIn"){
                return <PreEarlyCheckinModal
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="lateCheckout"){
                return <PostLateCheckoutModal
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="wakeUpCall"){
                return <WakeUpCallModal
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="houseKeeping"){
                return <HouseKeepingModal
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="conferenceRoom"){
                return <ConferenceRoomModal 
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="restaurantTable"){
                return <RestaurantTableModal 
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="spa"){
                // console.log("Spa Open")
                return <SpaRequestModal 
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="custom"){
                return <CustomModel
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="roomChange"){
                return <RoomChangeModel
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="extendStay"){
                return  <ExtendStayModel
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="getWifi"){
                return <GetWifiModel
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="food"){
                return <DiningModel
                    requestData = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="webCheckIn"){
                return <WebCheckInRequestModel
                    selectedRequest = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />
            }
            if(requestType==="checkOut"){
         
                return <Checkout
                    selectedRequest = {requestData}
                    setRequestType = {setRequestType}
                    setOpenRequestModal = {setOpenRequestModal}
                    setRequestData = {setRequestData}
                />

            }
            else{
                return <></>
            }

        }catch(error){
            console.log(error);
        }
    }


    // Date Filter
    const MONTHS = [
        "January","February","March","April","May","June",
        "July","August","September","October","November","December"
    ];

 




    return (
        <>
            {!isFetching && (isLoading && <PageLoader />)}
            <div className="p-4">

                {/* Page Header */}
                <div className="flex justify-between items-center mb-4">
                    <div className="flex gap-2 items-center">
                        <button
                            className="bg-[#F2F7FF] border-[1.5px] rounded-md p-1 z-0 mr-1"
                            onClick={() => closePast(false)}
                        >
                            <ArrowLeft size={19} />
                        </button>
                        <h2 className="text-[#262B33] font-medium tracking-[2.5px] text-xl">
                            PAST REQUESTS
                        </h2>
                    </div>
                    <button
                        className="flex items-center gap-2 border-[1.5px] rounded-md px-2 py-1"
                        onClick={() => setOpenFilter(!openFilter)}
                    >
                        <Funnel size={18} /> Filter
                    </button>
                    
                    {/* Filter Data  */}
                    {openFilter && (
                        <div className="absolute top-32 right-7 mt-2 border-[1.5px] rounded-md bg-white text-sm w-96 overflow-hidden z-10">
                            <div className="flex items-center justify-between bg-[#F2F7FF] px-3 py-2">
                                <h2 className="font-semibold">Filters</h2>
                                <button
                                    onClick={() => setOpenFilter(false)}
                                    className="bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                                >
                                    <X weight="bold" size={15} />
                                </button>
                            </div>
                            
                            {/* Filter Options */}
                            <div className="p-3 flex flex-col gap-3">
                                <>
                                    {/* Room Number Data  */}
                                    {/* <div>
                                        <label htmlFor="" className="font-medium">
                                            Room Number
                                        </label>
                                        <select
                                            className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                                tempFilters.roomNumber === ""
                                                    ? "text-gray-500"
                                                    : "text-black"
                                            }`}
                                            name="roomNumber"
                                            value={tempFilters.roomNumber}
                                            onChange={handleFilterChange}
                                        >
                                            <option
                                                value=""
                                                className="text-gray-500"
                                            >
                                                Choose Room Numbers
                                            </option>
                                            {
                                                Array.from(
                                                    new Set(
                                                        fetchData
                                                            ?.filter(
                                                                (d) => d.room_number,
                                                            )
                                                            .map((d) => d.room_number),
                                                    ),
                                                ).map((roomNumber, index) => (
                                                    <option
                                                        key={index}
                                                        value={roomNumber}
                                                    >
                                                        {roomNumber}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </div> */}
                                </>

                                {/* Check In Status  */}
                                <div>
                                    <label htmlFor="" className="font-medium">
                                        Check-in Status
                                    </label>
                                    <div className="flex gap-4 px-1 mt-1">
                                        <div className="flex items-center gap-1.5 w-1/2">
                                            <input
                                                type="checkbox"
                                                name="preCheckin"
                                                checked={tempFilters.preCheckin}
                                                onChange={handleFilterChange}
                                                id="preCheckin"
                                            />
                                            <label htmlFor="preCheckin">
                                                Pre Check-in
                                            </label>
                                        </div>
                                        <div className="flex items-center gap-1.5 w-1/2">
                                            <input
                                                type="checkbox"
                                                name="postCheckin"
                                                checked={
                                                    tempFilters.postCheckin
                                                }
                                                onChange={handleFilterChange}
                                                id="postCheckin"
                                            />
                                            <label htmlFor="postCheckin">
                                                Post Check-in
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Staff */}
                                <div>
                                    <label htmlFor="">Staff</label>
                                    <select
                                        className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                            tempFilters.staff === ""
                                                ? "text-gray-500"
                                                : "text-black"
                                        }`}
                                        name="staff"
                                        value={tempFilters.staff}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">Choose Staff</option>
                                        {Array.from(
                                            new Set(
                                                fetchData
                                                    ?.filter(
                                                        (d) =>
                                                            d.staff_member_name,
                                                    )
                                                    .map(
                                                        (d) =>
                                                            d.staff_member_name,
                                                    ),
                                            ),
                                        ).map((staffName, index) => (
                                            <option
                                                key={index}
                                                value={staffName}
                                            >
                                                {staffName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Date Filter */}

                                {/* Range Filter */}
                                <div className="flex flex-col gap-2">

                                    <div className="flex flex-col gap-2">

                                        <div className="text-sm font-medium text-gray-600">
                                            Date Range
                                        </div>

                                        <div className="flex gap-3">
                                            {/* Start Date */}
                                            <div className="flex flex-col">
                                                <span className="text-xs text-gray-500 mb-1">Start</span>
                                                <input
                                                    type="date"
                                                    value={tempFilters.startDate}
                                                    onChange={(e) =>
                                                    setTempFilters({
                                                        ...tempFilters,
                                                        startDate: e.target.value,
                                                    })
                                                    }
                                                    className="
                                                    px-3 py-2
                                                    rounded-lg
                                                    border border-gray-300
                                                    text-sm
                                                    focus:outline-none
                                                     
                                                    focus:border-blue-500
                                                    bg-white
                                                    "
                                                />
                                            </div>

                                            {/* End Date */}
                                            <div className="flex flex-col">
                                                <span className="text-xs text-gray-500 mb-1">End</span>
                                                <input
                                                    type="date"
                                                    value={tempFilters.endDate}
                                                    onChange={(e) =>
                                                    setTempFilters({
                                                        ...tempFilters,
                                                        endDate: e.target.value,
                                                    })
                                                    }
                                                    className="
                                                    px-3 py-2
                                                    rounded-lg
                                                    border border-gray-300
                                                    text-sm
                                                    focus:outline-none
                                                
                                                    focus:border-blue-500
                                                    bg-white
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                              
                                </div>


                                {/* Date */}
                                <div>
                                    <label>Date</label>
                                    <select
                                        className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                        tempFilters.date === "" ? "text-gray-500" : "text-black"
                                        }`}
                                        name="date"
                                        value={tempFilters.date}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">Choose Date</option>

                                        {Array.from(
                                        new Set(
                                            fetchData?.map(
                                            (d) => new Date(d.updated_at).getDate()
                                            )
                                        )
                                        )
                                        .sort((a, b) => a - b)
                                        .map((date) => (
                                            <option key={date} value={date}>
                                            {date}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Month */}
                                <div>
                                    <label>Month</label>
                                    <select
                                        className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                            tempFilters.month === ""
                                                ? "text-gray-500"
                                                : "text-black"
                                        }`}
                                        name="month"
                                        value={tempFilters.month}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">Choose Month</option>
                                        {Array.from(
                                            new Set(
                                                fetchData?.map(d =>
                                                    new Date(d.updated_at).getMonth()
                                                )
                                            )
                                        )
                                            .sort((a, b) => a - b)
                                            .map(monthIndex => (
                                                <option key={monthIndex} value={monthIndex}>
                                                    {MONTHS[monthIndex]}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                {/* Year */}
                                <div>
                                    <label>Year</label>
                                    <select
                                        className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                            tempFilters.year === ""
                                                ? "text-gray-500"
                                                : "text-black"
                                        }`}
                                        name="year"
                                        value={tempFilters.year}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">Choose Year</option>
                                        {Array.from(
                                            new Set(
                                                fetchData?.map(d =>
                                                    new Date(d.updated_at).getFullYear()
                                                )
                                            )
                                        )
                                            .sort((a, b) => b - a)
                                            .map(year => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                    </select>
                                </div>

        

                             

                            </div>

                            {/* Buttons For Filter */}
                            <div className="bg-[#F2F7FF] px-3 py-2 flex items-center justify-between">
                                <button
                                    className="text-[#ff7378] border-[1.5px] rounded-md px-2 py-1"
                                    onClick={resetFilters}
                                >
                                    Reset
                                </button>
                                <button
                                    className="bg-[#ff7378] px-3 py-1 rounded-md"
                                    onClick={applyFilters}
                                >
                                    Apply Filter
                                </button>
                            </div>

                        </div>
                    )}

                </div>

                {/* Render Filtered Data */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                    {filteredData.map((request) => (
                        <div
                            key={request.id}
                            className="bg-white rounded-md p-3 border border-gray-200 flex flex-col"
                        >
        


                            {/* Button to redirect the Reques  */}
                            <div className="flex items-center justify-between border-b pb-2 mb-2">
                                <h2 className="text-[#262B33]">
                                    <span className="text-[#B74044] mr-2 font-semibold">
                                        {request.type}
                                    </span>
                                </h2>
                                <button className="bg-[#F2F7FF] border-[1.5px] rounded-md p-1.5 z-0"
                                    onClick={()=>openRequest(request.id,request.type,request.booking_id,request.booked_room_id)}
                                >
                                    <ArrowUpRight size={19} />
                                </button>
                            </div>

                      

                            {/* Request Status And Type */}
                            <div className="flex items-center justify-between my-2">
                                <button
                                    className={`${
                                        request.status === "Completed_Hotel"
                                            ? "bg-[#e6f9f3] text-[#0a411684]"
                                            : "bg-[#FAE2E6] text-[#D02746]"
                                    } px-2 py-1 flex rounded-full items-center gap-1 text-xs`}
                                >
                                    {[
                                        "Closed_Hotel",
                                        "Closed_Guest",
                                    ].includes(request.status) && (
                                        <>
                                            <XCircle size={15} />
                                            <span>
                                                {request.status.includes(
                                                    "Hotel",
                                                )
                                                    ? "Closed by you"
                                                    : "Closed by guest"}
                                            </span>
                                        </>
                                    )}

                                    {
                                        [
                                            "Declined_Hotel",
                                            "Declined_Guest",
                                        ].includes(request.status) && (
                                            <>
                                                <XCircle size={15} />
                                                <span>
                                                    {request.status.includes(
                                                        "Hotel",
                                                    )
                                                        ? "Declined by you"
                                                        : "Declined by guest"}
                                                </span>
                                            </>
                                        )
                                    }
                                    {request.status === "Completed_Hotel" && (
                                        <>
                                            <CheckCircle size={15} />
                                            <span>Completed by you</span>
                                        </>
                                    )}
                                </button>

                                <button
                                    className={`${
                                        request.type.split(" ")[0] === "Pre"
                                            ? "bg-[#FAE2E6] text-[#D02746]"
                                            : "bg-[#ECE3FF] text-[#30214E]"
                                    } px-2 py-1 flex rounded-full items-center gap-2 text-xs font-semibold`}
                                >
                                    <span
                                        className={`w-1.5 h-1.5 ${
                                            request.type.split(" ")[0] === "Pre"
                                                ? "bg-[#ff7378]"
                                                : "bg-[#9983C6]"
                                        } rounded-full`}
                                    ></span>
                                    {serviceMap[request.type]}
                                </button>
                            </div>

                            {/* Request Footer */}
                            <div className="flex items-center justify-between">
                                <button className="text-[#737880] text-xs">
                                    Booking#{" "}
                                    <span
                                        className="text-[#FF5A5F] font-semibold w-10 overflow-hidden truncate"
                                        title={request?.booking_id || ""} 
                                    >
                                        {request?.booking_id &&  request?.booking_id.slice(0, 6) + ".."}
                                        
                                    </span>
                                </button>
                                {/* Date */}
                                <div className="flex items-center gap-2 text-xs text-gray-600 ">
                                    
                                    <span>
                                        {request.updated_at
                                        ? new Date(request.updated_at).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "long",
                                            year: "numeric",
                                            })
                                        : "N/A"}
                                    </span>
                                </div>
                                {/* <button className="text-xs">
                                    <span className="text-[#737880]">
                                        Last updated
                                    </span>{" "}
                                    {getRelativeTime(request.updated_at)}
                                </button> */}
                            </div>

                        </div>
                    ))}
                </div>


                {
                    openRequestModal ? renderRequestModal(requestType) : <></>
                }

            </div>
        </>
    );
};

export default PastRequests;
